import * as controladoriaV2Store from './store'

export function controladoriaV2Module({ store }) {
  store.registerModule('controladoria-v2', {
    ...controladoriaV2Store,
    namespaced: true,
  })
}
